


























































































import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { FormItem, Select, Option } from 'element-ui';

// components
import NullableInput from '@/components/element-ui/NullableInput.vue';
import UtcDatePicker from '@/components/element-ui/UtcDatePicker.vue';
import PortFilter from '@/components/inputs/PortFilter.vue';
import PortSelect2 from '@/components/inputs/PortSelect2.vue';
import VesselUpsertModal from '@/components/modals/VesselUpsert.vue';

// mixins
import vessels from '@/mixins/vesselOptions';

// lodash
import get from 'lodash/get';
import debounce from 'lodash/debounce';

// types
import {
  MilestoneInput,
  MilestoneFields,
  VesselFields
} from '@/types/graphql/schemaTypes';

@Component({
  components: {
    PortSelect2,
    UtcDatePicker,
    VesselUpsertModal,
    'el-form-item': FormItem,
    'el-select': Select,
    'el-option': Option,
    'el-input': NullableInput
  }
})
export default class SeaTransportation extends Mixins(vessels) {
  @Prop() private milestone!: MilestoneFields;

  public $refs!: {
    vesselSelect: HTMLElement;
  };

  private debouncer = debounce((self) => { self.$emit('update', self.milestoneInput); }, 300);
  private editVessel: VesselFields | null = this.milestone?.vessel || null;
  private isCreate = false;
  private openEditModal = false;
  private selectedVesselId: string | null = this.milestone?.vessel?.id || null;
  private milestoneInput: MilestoneInput = {
    details: {
      voyageNumber: get(this.milestone, 'details.voyageNumber', null),
      blNumber: get(this.milestone, 'details.blNumber', null)
    },
    vesselId: this.milestone.vesselId,
    estimatedDateOfArrival: get(this.milestone, 'estimatedDateOfArrival', null),
    estimatedDateOfDeparture: get(this.milestone, 'estimatedDateOfDeparture', null),
    podId: get(this.milestone, 'pod.id', null),
    polId: get(this.milestone, 'pol.id', null)
  };

  public created(): void {
    this.searchVesselString = this.milestone?.vessel?.name || '';
  }

  public openVesselEdit(vessel: VesselFields) {
    this.$refs.vesselSelect.blur();
    this.editVessel = vessel;
    this.openEditModal = true;
    this.isCreate = false;
  }

  public openVesselCreate() {
    this.$refs.vesselSelect.blur();
    this.editVessel = null;
    this.openEditModal = true;
    this.isCreate = true;
  }

  public vesselUpserted(editedVessel: VesselFields) {
    if (!this.editVessel) {
      this.editVessel = editedVessel;
    }
    if (this.isCreate) {
      this.searchVesselString = editedVessel?.name;
      this.updateVesselOptions();
    }
    this.selectedVesselId = editedVessel?.id;
    this.editVessel.naccsCode = editedVessel?.naccsCode;
    this.editVessel.imo = editedVessel?.imo;
    this.editVessel.mmsi = editedVessel?.mmsi;
  }

  @Watch('milestoneInput', { deep: true })
  private emitUpdate(milestoneInput: MilestoneInput) {
    this.debouncer(this);
  }

  @Watch('selectedVesselId')
  private updateVesselSelect(newVesselId: string | null) {
    if (newVesselId !== this.milestone.vesselId) {
      this.milestoneInput.vesselId = newVesselId || null;
    }
  }
}
